import axios from 'axios';
import { serverUrl } from '../../ApiRoute';
import store from '../redux';
import { loadHouse } from '../redux/action/CollectiveHouse';

/** Route that writes a device's desired (`expected*`) schedule. */
export const DEVICE_UPDATE_ROUTE = '/default/device/update';

/**
 * This service authenticates with a bare `accesstoken` header rather than the
 * `Authorization: Bearer` the subscription cloud takes.
 */
const authHeaders = () => ({
  'Content-Type': 'application/json',
  accesstoken: store.getState().login?.access || '',
});

/**
 * Asks a device to move to a new schedule.
 *
 * The write lands on `expectedDefaultSchedule` / `expectedTempSchedule`; the
 * matching `current*` object only changes once the device has picked the
 * schedule up, which is what the table's pending state reflects.
 */
export const updateDeviceSchedule = async ({ deviceId, section, values }) => {
  try {
    const response = await axios.post(
      `${serverUrl.energiSync}${DEVICE_UPDATE_ROUTE}`,
      { deviceId, [section.writeKey]: values },
      { headers: authHeaders() }
    );

    if (response.status === 200 && response.data?.success !== false) {
      return { success: true, message: response.data?.message || 'Schedule sent to the device', data: response.data };
    }

    return { success: false, message: response.data?.message || 'Could not update the schedule' };
  } catch (error) {
    let message = error.message;
    if (error.response && error.response.data) {
      message = error.response.data.message || error.response.data.error || message;
    }
    return { success: false, message };
  }
};

/**
 * Loads a house into `mutipleHouse` so its EnergiSync devices can be listed.
 * Deliberately not `fetchHouseDetails` — that also rewrites the user's default
 * property, and picking a property to review here is not the same as switching
 * the property the dashboard opens on.
 */
export const loadHouseForPicker = async (houseId, phoneNumber) => {
  try {
    const response = await axios.get(
      `${serverUrl.sub}/api/fetch/house2/${houseId}/+91${phoneNumber}?user=+91${phoneNumber}`
    );

    if (response.status === 200) {
      store.dispatch(loadHouse(houseId, response.data));
      return { success: true, data: response.data };
    }

    return { success: false, message: 'Could not load this property' };
  } catch (error) {
    let message = error.message;
    if (error.response && error.response.data) {
      message = error.response.data.message || message;
    }
    return { success: false, message };
  }
};
